import { Reducer } from 'redux';

import {
    createFetchReducer, INITIAL_FETCH_STATE
} from '../middleware';
import { AUTH_STATE_NAME } from './auth.actions';
import {
    AuthData, AuthState
} from './auth.types';

export const INITIAL_AUTH_STATE: AuthState = INITIAL_FETCH_STATE;

export const getAuthReducer = (): Reducer<AuthState> => {
    return createFetchReducer<AuthData>(
        AUTH_STATE_NAME,
        INITIAL_FETCH_STATE
    );
};
